export default {
  permanecerConectado: state => state.permanecerConectado,
  profile: state => state.profile,
  askPasswordResetRequestStatus: state => state.askPasswordResetRequestStatus,
  passwordRecoveryRequestStatus: state => state.passwordRecoveryRequestStatus,
  profileRequestStatus: state => state.profileRequestStatus,
  signInRequestStatus: state => state.signInRequestStatus,
};